var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-title d-flex align-items-center"},[_vm._t("title")],2),_c('div',{staticClass:"card-body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }